// actions.js
import {
  SET_WALLPAPER_TRANSPARENCY,
  SET_WALLPAPER_RESIZING,
  SET_WALLPAPER_OVERLAY_COLOR,
  SET_BG_WALLPAPER,
  SET_IS_PATTERN,
  SET_SEGMENT_BG_COLOR,
  SET_CURRENT_BG,
  SET_SELECTED_COLOR_TYPE,
  SET_PATTERN_COLOR,
  SET_BG_GRADIENT,
  UPDATE_WALLPAPER_INITAL_STATE,
  RESET_WHEEL_BG_TO_INITIAL_STATE,
  SET_WALLPAPER_HUE_PERCENTAGE,
  SET_WALLPAPER_HUE_COLOR,
} from '../types';

export const setWallpaperTransparency = (value) => ({
  type: SET_WALLPAPER_TRANSPARENCY,
  payload: value,
});

export const setWallpaperResizing = (value) => ({
  type: SET_WALLPAPER_RESIZING,
  payload: value,
});

export const setWallpaperOverlayColor = (value) => ({
  type: SET_WALLPAPER_OVERLAY_COLOR,
  payload: value,
});

export const setBgWallpaper = (value, isPattern) => ({
  type: SET_BG_WALLPAPER,
  payload: { value, isPattern },
});

export const setBgGradient = (value) => ({
  type: SET_BG_GRADIENT,
  payload: { value },
});

export const setIsPattern = (value) => ({
  type: SET_IS_PATTERN,
  payload: value,
});

export const setSegmentBgColor = (value) => ({
  type: SET_SEGMENT_BG_COLOR,
  payload: value,
});

export const setCurrentBg = (value) => ({
  type: SET_CURRENT_BG,
  payload: value,
});

export const setSelectedColorType = (value) => ({
  type: SET_SELECTED_COLOR_TYPE,
  payload: value,
});

export const setPatternColor = (value) => ({
  type: SET_PATTERN_COLOR,
  payload: value,
});

export const updateWallpaperInitialState = (payload) => ({
  type: UPDATE_WALLPAPER_INITAL_STATE,
  payload,
});

export const resetToWheelBgToInitialState = () => ({
  type: RESET_WHEEL_BG_TO_INITIAL_STATE,
});

export const setWallpaperHuePercentage = (value) => ({
  type: SET_WALLPAPER_HUE_PERCENTAGE,
  payload: value,
});

export const setWallpaperHueColor = (value) => ({
  type: SET_WALLPAPER_HUE_COLOR,
  payload: value,
});
